export default "__VITE_ASSET__54557865__"